module.exports = __webpack_public_path__ + "static/media/krishe-logo.f26f2555.svg";